class PromptService
  @$inject = ['$uibModal']

  constructor: (@modal) ->

  open: (view, callback, options) ->
    @modal.open(
        angular.extend({
          backdrop: 'static'
          keyboard: false
          templateUrl: view + if @debug then '?no-cache=' + (new Date()).getTime() else ''
          controller: 'promptModalController as ctrl'
        }, options)
      )
      .result
      .then((retorno) ->
        callback(retorno) if callback
      )

angular.module('eficienciaFiscalModule').service('promptService', PromptService)


class PromptModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance']

  constructor: ($injector, @modalInstance) ->
    super($injector)

  submit: (form, data) ->
    if form.$valid
      @modalInstance.close(data)

  cancel: () ->
    @modalInstance.dismiss('cancel')

angular.module('eficienciaFiscalModule').controller('promptModalController', PromptModalController)
